import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table table-responsive-md border border-gray overflow-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Billable"),
    /*#__PURE__*/_createElementVNode("th", null, "Payer"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Time"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Billed"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_MidnightSplitRow = _resolveComponent("MidnightSplitRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        (_ctx.detail.length == 0 && _ctx.newDetail.length == 0)
          ? (_openBlock(), _createBlock(_component_TableEmpty, {
              key: 0,
              "col-span": _ctx.columns,
              component: _ctx.diagnoses,
              "secondary-message": "No Payroll Detail Found"
            }, null, 8 /* PROPS */, ["col-span", "component"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskShifts, (detail) => {
          return (_openBlock(), _createBlock(_component_MidnightSplitRow, {
            detail: detail,
            id: _ctx.id,
            "snapshot-view": _ctx.snapshotView
          }, null, 8 /* PROPS */, ["detail", "id", "snapshot-view"]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.newDetail.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.newDetail, (detail) => {
              return (_openBlock(), _createBlock(_component_MidnightSplitRow, {
                detail: detail,
                "is-add-requested": true,
                "save-new-detail": _ctx.saveNewDetail,
                "cancel-save-new-detail": _ctx.cancelSaveNewDetail,
                "is-new-terminal": _ctx.isNewTerminal,
                "snapshot-view": _ctx.snapshotView
              }, null, 8 /* PROPS */, ["detail", "save-new-detail", "cancel-save-new-detail", "is-new-terminal", "snapshot-view"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}